import { useEffect, useState } from 'react';

/**
 * Deal items into columns left to right, row by row, so a list sorted newest
 * first reads newest first across the top. CSS `columns` fills each column top
 * to bottom instead, which puts the second-newest item under the first and
 * starts column two a third of the way down the list.
 */
export function distributeColumns<T>(items: T[], columnCount: number): T[][] {
  const count = Math.max(1, Math.floor(columnCount));
  const columns: T[][] = Array.from({ length: count }, () => []);
  items.forEach((item, i) => columns[i % count].push(item));
  return columns;
}

const SM = '(min-width: 640px)';
const LG = '(min-width: 1024px)';

function currentCount(): number {
  if (typeof window === 'undefined' || !window.matchMedia) return 1;
  if (window.matchMedia(LG).matches) return 3;
  if (window.matchMedia(SM).matches) return 2;
  return 1;
}

/** 1 / 2 / 3 columns at Tailwind's base / sm / lg breakpoints. */
export function useColumnCount(): number {
  const [count, setCount] = useState(currentCount);
  useEffect(() => {
    if (!window.matchMedia) return;
    const queries = [window.matchMedia(SM), window.matchMedia(LG)];
    const update = () => setCount(currentCount());
    queries.forEach((q) => q.addEventListener('change', update));
    update();
    return () => queries.forEach((q) => q.removeEventListener('change', update));
  }, []);
  return count;
}
